var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './index.scss';
import classnames from 'classnames';
import { arrayOf, bool, node, oneOfType, string } from 'prop-types';
import React from 'react';
const SidebarSection = (_a) => {
    var { title, className, isActive, children } = _a, rest = __rest(_a, ["title", "className", "isActive", "children"]);
    SidebarSection.propTypes = {
        title: string,
        className: string,
        isActive: bool,
        children: oneOfType([
            arrayOf(node),
            node,
        ]),
    };
    const sidebarSectionClass = classnames('sidebar-section', className, {
        active: isActive,
    });
    return (React.createElement("div", Object.assign({ className: sidebarSectionClass }, rest),
        React.createElement("div", { className: 'sidebar-section-header' },
            React.createElement("h6", { className: 'sidebar-section-heading' }, title)),
        React.createElement("div", { className: 'sidebar-section-body' }, children)));
};
export default SidebarSection;
